import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { logoutUserState } from 'store/auth/slices/AuthSlice';

interface CustomerCheckoutState {
  activeStepIndex: number;
  selectedAddressId: string;
  submittedAddressPayload: Record<string, any> | null;
  quickRegisterData: Record<string, any> | null;
  selectedShippingFfl: Record<string, any> | null;
  paymentForms: Record<string, any>;
  submittedSections: Record<string, any>;
  orderNumber: string | null;
}

const initialState: CustomerCheckoutState = {
  activeStepIndex: 0,
  selectedAddressId: '',
  submittedAddressPayload: null,
  quickRegisterData: null,
  selectedShippingFfl: null,
  paymentForms: {},
  submittedSections: {},
  orderNumber: null,
};

export const CustomerCheckoutSlice = createSlice({
  name: 'customerCheckout',
  initialState,
  reducers: {
    setCheckoutActiveStep(state, action: PayloadAction<number>) {
      state.activeStepIndex = action.payload;
    },
    setCheckoutSelectedAddressId(state, action: PayloadAction<string>) {
      state.selectedAddressId = action.payload;
    },
    setCheckoutSubmittedAddressPayload(state, action: PayloadAction<Record<string, any> | null>) {
      state.submittedAddressPayload = action.payload;
    },
    setCheckoutQuickRegisterData(state, action: PayloadAction<Record<string, any> | null>) {
      state.quickRegisterData = action.payload;
    },
    setCheckoutSelectedShippingFfl(state, action: PayloadAction<Record<string, any> | null>) {
      state.selectedShippingFfl = action.payload;
    },
    setCheckoutPaymentForm(
      state,
      action: PayloadAction<{ groupId: string; data: Record<string, any> }>
    ) {
      state.paymentForms[action.payload.groupId] = action.payload.data;
    },
    setCheckoutSubmittedSection(
      state,
      action: PayloadAction<{ groupId: string; data: Record<string, any> }>
    ) {
      state.submittedSections[action.payload.groupId] = action.payload.data;
    },
    setCheckoutOrderNumber(state, action: PayloadAction<string | null>) {
      state.orderNumber = action.payload;
    },
    resetCheckoutState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutUserState, () => initialState);
  },
});

export const {
  resetCheckoutState,
  setCheckoutActiveStep,
  setCheckoutPaymentForm,
  setCheckoutQuickRegisterData,
  setCheckoutSelectedAddressId,
  setCheckoutSubmittedAddressPayload,
  setCheckoutSelectedShippingFfl,
  setCheckoutSubmittedSection,
  setCheckoutOrderNumber,
} = CustomerCheckoutSlice.actions;

export default CustomerCheckoutSlice.reducer;
